import TextField, { TextFieldProps } from "@mui/material/TextField";
import { get } from "radash";
import { Controller, UseControllerProps } from "react-hook-form";

export type TextAreaProps = TextFieldProps & UseControllerProps<any>;

const TextArea = (props: TextAreaProps) => {
  const { control, name, ...rest } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: state }) => (
        <TextField
          {...field}
          fullWidth
          multiline
          rows={4}
          title={rest.label as string}
          error={!!get(state.errors, name)}
          placeholder={rest.placeholder || (rest.label as string)}
          {...rest}
        />
      )}
    />
  );
};

export default TextArea;
